import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./journaldetails.module.css";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, Button } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import axios from "axios";
import dayjs from "dayjs";
import { Link, useHistory } from "react-router-dom";
import Loader from "../../../../components/Loader";
import Footer from "../../../../components/Footer";
import { TableLoaderSmall } from "../../../../components/LoaderC";
import AddJournal from "../AddJournal";
import MobileJournalView from "./components/MobileJournalView";
import VideoThumbnail from "./VideoThumbnail";

function DotIcon() {
  return (
    <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="12" r="12" />
    </svg>
  );
}

const JournalDetails = ({ history, match }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const { id } = match.params;
    const redirect = useHistory();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [openEditForm, setOpenEditForm] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [journalDetails, setJournalDetails] = useState(null);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [idx, setIdx] = useState(0);
    const [propertyList, setPropertyList] = useState([]);
    const [tenantList, setTenantList] = useState([]);

    const photos = journalDetails?.images || [];
    const hasPhotos = photos.length > 0;
    const currentMedia = photos[idx];
    const currentMediaUrl = currentMedia?.image_url || "";
    const currentMediaExt = currentMediaUrl.split(".").pop().split("?")[0].toLowerCase();
    const videoExtensions = ["mp4", "mov", "avi", "mkv", "webm"];
    const isCurrentVideo = videoExtensions.includes(currentMediaExt);

    const navGallery = (dir) => {
        setIdx((prev) => (prev + dir + photos.length) % photos.length);
    };

    const openLightbox = () => setLightboxOpen(true);
    const closeLightbox = () => setLightboxOpen(false);

    const getTenantNames = () => {
        if (journalDetails?.tenant_names) {
            return journalDetails.tenant_names;
        }
        if (journalDetails?.tenant_name) {
            return journalDetails.tenant_name;
        }
        if (journalDetails?.tenants && tenantList?.length > 0) {
            const tenantIds = String(journalDetails.tenants).split(",").map(id => parseInt(id.trim(), 10));
            const names = tenantIds
                .map(id => {
                    const match = tenantList.find(t => t.value === id);
                    return match ? match.label : null;
                })
                .filter(name => name !== null);
            if (names.length > 0) {
                return names.join(", ");
            }
        }
        return "";
    };

    const tenantNamesStr = getTenantNames();

    useEffect(() => {
        const getPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journal-property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch(() => { });
        }

        getPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchTenants() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_CASE_API_URL + "v1/property-tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let tFinalList = [];
                let tFinalList2 = [];

                let templistNew = response.data.data;

                templistNew?.map((item) => {
                    tFinalList.push({ label: item.label, parent: 1 });
                    item?.options?.map((subItem) => {
                        tFinalList.push({
                            value: subItem.value,
                            label: subItem.label,
                            parent: 0,
                            propertyId: item?.id,
                        });
                        return false;
                    });

                    return false;
                });

                templistNew?.map((item) => {
                    item?.options?.map((subItem) => {
                        tFinalList2.push({
                            group_id: item?.id,
                            group: item?.label,
                            value: subItem?.value,
                            label: subItem.label
                        });
                        return false;
                    });

                    return false;
                });

                setTenantList(tFinalList2);
            }).catch((error) => { });
        }

        fetchTenants();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const geNotificationDetails = async () => {
            setContentLoading(true);

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_TENANT_API_URL + "v1/journals/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setJournalDetails(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        geNotificationDetails();
    }, [getAccessTokenSilently, id]);

    const deleteConfirm = async () => {
        setLoading(true);
        setDeleteModalOpen(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_TENANT_API_URL + 'v1/journals/' + id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);
            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setTimeout(() => {
                redirect.push("/security/journal/list");
            }, 2000);
        }).catch(error => {
            setLoading(false);
        });
    }

    const updateJournal = (data) => {
        setJournalDetails(data);
    }

    return (
        <React.Fragment>
            {loading && <Loader />}
            <Helmet title={"Journal Details"} />

            <div className={`${styles.mainCard}`}>
                <div className={`${styles.SMProCusRow}`}>

                    <div className={`${styles.BreadcrumbHeadSec}`}>
                        <nav aria-label="breadcrumb">
                            <ol className={`${styles.breadcrumb}`}>
                                <li className={`${styles.breadcrumbItem}`}>
                                    <span>
                                        <Home />
                                    </span>
                                    Security
                                </li>
                                <li className={`${styles.breadcrumbItem}`}>
                                    <Link to={"/security/journal/list"}>
                                        Journals
                                    </Link>
                                </li>
                                <li className={`${styles.breadcrumbItem} ${styles.active}`}>
                                    {journalDetails ? `Entry #JR-${journalDetails.id}` : 'Details'}
                                </li>
                            </ol>
                        </nav>
                    </div>

                    {contentLoading && (
                        <div className="Loader TableLoader">
                            <TableLoaderSmall />
                        </div>
                    )}

                    {!contentLoading && journalDetails && (
                        <>
                            <div className={styles.pageHead}>
                                <div className={styles.headLeft}>
                                    <div 
                                        className={styles.backBtn} 
                                        onClick={() => redirect.push("/security/journal/list")}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                            <line x1="19" y1="12" x2="5" y2="12" />
                                            <polyline points="12 19 5 12 12 5" />
                                        </svg>
                                    </div>
                                    <div className={styles.headTitleWrap}>
                                        <h1>Journal Entry</h1>
                                        <div className={styles.headSub}>
                                            {journalDetails?.is_unusual === 1 ? 'Unusual Activity' : 'Regular Entry'} · {journalDetails?.property_name}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.headActions}>
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && (
                                        <button 
                                            className={`${styles.btn} ${styles.btnDangerGhost}`}
                                            onClick={() => setDeleteModalOpen(true)}
                                        >
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <polyline points="3 6 5 6 21 6" />
                                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                            </svg>
                                            Delete
                                        </button>
                                    )}
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:update") > -1 && (
                                        <button 
                                            className={`${styles.btn} ${styles.btnGhost}`}
                                            onClick={() => setOpenEditForm(true)}
                                        >
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z" />
                                            </svg>
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className={styles.grid}>
                                {/* LEFT: entry content */}
                                <div className={styles.FirstSec}>
                                    <div className={styles.card}>
                                        {journalDetails?.is_unusual === 1 && (
                                            <div className={styles.flagBanner}>
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                                    <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                                                </svg>
                                                <span>Flagged as an unusual activity requiring follow-up</span>
                                            </div>
                                        )}

                                        {hasPhotos && (
                                            <div className={styles.gallery}>
                                                <div className={styles.galleryMain}>
                                                    {isCurrentVideo ? (
                                                        <div onClick={openLightbox} style={{ cursor: 'pointer' }}>
                                                            <VideoThumbnail videoUrl={currentMediaUrl} />
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={currentMediaUrl}
                                                            alt="Journal evidence"
                                                            onClick={openLightbox}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    )}
                                                    <div className={styles.galleryCount}>
                                                        {idx + 1} / {photos.length}
                                                    </div>
                                                    <div
                                                        className={`${styles.galleryNav} ${styles.prev}`}
                                                        onClick={() => navGallery(-1)}
                                                    >
                                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                                                            <polyline points="15 18 9 12 15 6" />
                                                        </svg>
                                                    </div>
                                                    <div
                                                        className={`${styles.galleryNav} ${styles.next}`}
                                                        onClick={() => navGallery(1)}
                                                    >
                                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                                                            <polyline points="9 18 15 12 9 6" />
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div className={styles.thumbRow}>
                                                    {photos.map((p, i) => {
                                                        const ext = p?.image_url.split(".").pop().split("?")[0].toLowerCase();
                                                        const isVid = videoExtensions.includes(ext);
                                                        return (
                                                            <div
                                                                key={p?.image_url}
                                                                className={`${styles.thumb} ${i === idx ? styles.active : ''}`}
                                                                onClick={() => setIdx(i)}
                                                            >
                                                                {isVid ? (
                                                                    <VideoThumbnail videoUrl={p?.image_url} />
                                                                ) : (
                                                                    <img src={p?.image_url} alt={`Thumbnail ${i + 1}`} />
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                        <div className={`${styles.descSection} ${!hasPhotos ? styles.noGallery : ''}`}>
                                            <div className={styles.descLabel}>Report Details</div>
                                            <div 
                                                className={styles.descText} 
                                                dangerouslySetInnerHTML={{ __html: journalDetails?.description }}
                                            />
                                        </div>

                                        <div className={styles.entryMetaStrip}>
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12 6 12 12 16 14" />
                                            </svg>
                                            <span>Submitted {dayjs(journalDetails?.date).format("MM/DD/YYYY")}</span>
                                            <span className={styles.divider}></span>
                                            <span>Entry #JR-{journalDetails?.id}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* RIGHT: metadata */}
                                <div>
                                    <div className={`${styles.card} ${styles.submitterCard}`}>
                                        <div className={styles.submitterAv}>{journalDetails?.user_initial || "U"}</div>
                                        <div>
                                            <div className={styles.submitterName}>{journalDetails?.user_name || "Unknown"}</div>
                                            <div className={styles.submitterRole}>Submitted by · Staff</div>
                                        </div>
                                    </div>

                                    <div className={`${styles.card} ${styles.metaCard}`}>
                                        <div className={styles.metaCardTitle}>Entry Information</div>

                                        <div className={styles.metaRow}>
                                            <div className={styles.metaIcon}>
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <rect x="3" y="4" width="18" height="18" rx="2" />
                                                    <line x1="16" y1="2" x2="16" y2="6" />
                                                    <line x1="8" y1="2" x2="8" y2="6" />
                                                    <line x1="3" y1="10" x2="21" y2="10" />
                                                </svg>
                                            </div>
                                            <div className={styles.metaBody}>
                                                <div className={styles.metaLabel}>Submitted Date</div>
                                                <div className={styles.metaValue}>{dayjs(journalDetails?.date).format("MM/DD/YYYY")}</div>
                                            </div>
                                        </div>

                                        <div className={styles.metaRow}>
                                            <div className={styles.metaIcon}>
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                                </svg>
                                            </div>
                                            <div className={styles.metaBody}>
                                                <div className={styles.metaLabel}>Property</div>
                                                <div className={styles.metaValue}>{journalDetails?.property_name || "N/A"}</div>
                                            </div>
                                        </div>

                                        {tenantNamesStr && (
                                            <div className={styles.metaRow}>
                                                <div className={styles.metaIcon}>
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                        <circle cx="12" cy="7" r="4" />
                                                    </svg>
                                                </div>
                                                <div className={styles.metaBody}>
                                                    <div className={styles.metaLabel}>Tenant(s)</div>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '4px' }}>
                                                        {tenantNamesStr.split(',').map((name, i) => {
                                                            const trimmedName = name.trim();
                                                            if (!trimmedName) return null;
                                                            const initials = trimmedName.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
                                                            return (
                                                                <div key={i} className={styles.tenantChip}>
                                                                    <div className={styles.av}>{initials}</div>
                                                                    <span>{trimmedName}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className={styles.metaRow}>
                                            <div className={styles.metaIcon}>
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M9 12l2 2 4-4" />
                                                    <circle cx="12" cy="12" r="10" />
                                                </svg>
                                            </div>
                                            <div className={styles.metaBody}>
                                                <div className={styles.metaLabel}>Any unusual activities or events to report</div>
                                                <span
                                                    className={`${styles.statusBadge} ${
                                                        journalDetails?.is_unusual === 1 ? styles.flagged : styles.normal
                                                    }`}
                                                    style={{ marginTop: '4px' }}
                                                >
                                                    <DotIcon />
                                                    {journalDetails?.is_unusual === 1 ? 'Yes' : 'No'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </div>

            <MobileJournalView 
                journalDetails={journalDetails} 
                setDeleteModalOpen={setDeleteModalOpen.bind(this)} 
                setOpenEditForm={setOpenEditForm.bind(this)} 
            />

            <Dialog
                open={openEditForm}
                fullWidth
                maxWidth="sm"
                onClose={() => setOpenEditForm(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp MobileForm"
            >
                <DialogTitle id="alert-dialog-title">
                    <button className={`${styles.BackAddBU}`} onClick={() => setOpenEditForm(false)}><ArrowLeft/></button>
                    <span>Edit Journal</span>
                    <button onClick={() => setOpenEditForm(false)}>
                        <X />
                    </button>
                </DialogTitle>
                <DialogContent className={`${styles.RequestBodyPop}`}>
                    <AddJournal 
                        journalData={journalDetails} 
                        propertyList={propertyList} 
                        allTenantList={tenantList} 
                        setOpenAddForm={setOpenEditForm.bind(this)} 
                        setLoading={setLoading.bind(this)} 
                        setSnackbarMsg={setSnackbarMsg.bind(this)} 
                        setSnackbarOpen={setSnackbarOpen.bind(this)} 
                        onSubmitLocal={updateJournal.bind(this)} 
                    />
                </DialogContent>
            </Dialog>

            <Dialog
                open={deleteModalOpen}
                fullWidth
                maxWidth="sm"
                onClose={() => setDeleteModalOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="NewPopUp"
            >
                <DialogTitle id="alert-dialog-title">
                    Are you sure you want to delete the Journal Entry?{" "}
                    <button onClick={() => setDeleteModalOpen(false)}>
                        <X />
                    </button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <div className="ModalFormGroup">
                            <label className="PopupBodyText">
                                The Journal Entry will be removed immediately. You can't
                                undo this action.
                            </label>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className="CancelPopupBU" onClick={deleteConfirm}>Delete</Button>
                    <Button
                        onClick={() => setDeleteModalOpen(false)}
                        className="SubmitPopupBU"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <div className={`${styles.DetailsFooter} FooterBack`}>
                <Footer />
            </div>

            <div
                className={`${styles.lightbox} ${lightboxOpen ? styles.open : ''}`}
                onClick={closeLightbox}
            >
                <div className={styles.lightboxClose}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </div>
                {hasPhotos && (
                    isCurrentVideo ? (
                        <video src={currentMediaUrl} controls autoPlay className={styles.lightboxVideo} onClick={(e) => e.stopPropagation()} />
                    ) : (
                        <img src={currentMediaUrl} alt="Journal evidence" onClick={(e) => e.stopPropagation()} />
                    )
                )}
            </div>

            <Snackbar
                open={snackbarOpen}
                onClose={() => setSnackbarOpen(false)}
                TransitionComponent={Slide}
                message={snackbarMsg}
                autoHideDuration={10000}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={() => setSnackbarOpen(false)}
                    >
                        <X />
                    </IconButton>
                }
            />
        </React.Fragment>
    );
};

export default withAuthenticationRequired(JournalDetails, {
    onRedirecting: () => <Loader />,
});
